import { useEffect, useMemo } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { updateExportDataAtom } from '@components/export/atom';
import { apiAccountsDetailsAtom, appAccountsDetailsAtom, videoAccountsDetailsAtom } from './atoms';
import { useTableExportMetricData } from './hooks/useExportMetric';

// Registers the list of selected account names so the CSV header can show every
// selected c3 account (not just the logged-in one).
const useSetExportAccountNames = () => {
  const videoAccounts = useAtomValue(videoAccountsDetailsAtom);
  const appAccounts = useAtomValue(appAccountsDetailsAtom);
  const apiAccounts = useAtomValue(apiAccountsDetailsAtom);
  const updateExportData = useSetAtom(updateExportDataAtom);

  const accountNames = useMemo(() => {
    const selected = [...videoAccounts, ...appAccounts, ...apiAccounts]
      .filter((account) => account?.isSelected)
      .map((account) => account.customerName);
    return Array.from(new Set(selected));
  }, [videoAccounts, appAccounts, apiAccounts]);

  useEffect(() => {
    const path = ['meta', 'accountNames'];
    updateExportData({ action: '$set', path, data: accountNames });
    return () => {
      updateExportData({ action: '$unset', path });
    };
  }, [accountNames, updateExportData]);
};

/**
 * Headless component mounted for the whole Usage Dashboard (both timeseries and
 * table views). It keeps the export payload complete regardless of the visible
 * view: the selected account names for the header, and the per-account table
 * breakdown for every product.
 */
export const UsageExportRegistrar = () => {
  useSetExportAccountNames();
  useTableExportMetricData('EI');
  useTableExportMetricData('APP');
  useTableExportMetricData('API');
  return null;
};
